import { Component, Vue } from 'vue-property-decorator'
@Component
export class CommonMixins extends Vue {
  checkListChange () {}

  tableShowColumnListCheckedChange () {}

  resetBtn () {
    let _that: any = this
    _that.searchList.forEach(item => {
      item.content = ''
    })
  }

  tableRowClassName ({ row, rowIndex }) {
    if (rowIndex % 2 === 0) {
      return 'warning-row'
    } else {
      return 'success-row'
    }
  }

  getAllFatherNode (id) {
    let _that: any = this
    function treeFindPath (tree, func, path = []) {
      if (!tree) return []
      for (const data of tree) {
        // 这里按照你的需求来存放最后返回的内容吧
        path.push(data)
        if (func(data)) return path
        if (data.children) {
          const findChildren = treeFindPath(data.children, func, path)
          if (findChildren.length) return findChildren
        }
        path.pop()
      }
      return []
    }
    let result = treeFindPath(_that.treeDataForOrganatizion, data => data.id === id)
    return result.map(item => item.id)
  }
}
